import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import { IonicPage, NavParams } from 'ionic-angular';
import { VariablesProvider } from '../../providers/variables/variables';
import { PicajesPage } from '../../pages/picajes/picajes';
import { ViewController } from 'ionic-angular';
import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { ObjetoslinPage } from '../../pages/objetoslin/objetoslin';

import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Events } from 'ionic-angular';

import * as moment from 'moment';

import { HomePage } from '../../pages/home/home';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import * as XLSX from '../../xlsx';
import { NgZone  } from '@angular/core';

import { File } from '@ionic-native/file';
import { ChangeDetectorRef } from '@angular/core';


/**
 * Generated class for the UserlinPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reservaslin',
  templateUrl: 'reservaslin.html',
})
export class ReservaslinPage {
  diasdefiesta;
  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;

  myForm: FormGroup;
  formulario = {numerodias1:"",obra1:"",obs1:"",sup1:""};

  resultado;
  date: string = "";
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  //cabecera = []; //= {valor: "1",color: "1"}
  trabajadores;
  objetos;
  obras;
  puestos;
  turnos;
  valo="654321123456" ;
  trabajadoresKeys;
  values:Array<string> = [];
  rs_xls;
  muestragif;
  reserva:any;
  todosLosVehiculos;
  nombreVehiculos;
  vehiculoElegido = "";
  diasOcupados;
  primeravez = "si";
  ID;
  solodia;
  isEnabled:boolean=false;
  horainicial;
  horafinal;
  trabajador;
  codigo;
  textoboton;

  horas: Array<string> = ["00", "01", "02","03", "04", "05","06", "07", "08","09", "10", "11","12", "13", "14","15", "16", "17","18", "19", "20","21", "22", "23","24"];
  dias: Array<string> = ["Lun", "Mar", "Mie","Jue", "Vie", "Sab","Dom"];

  //Arrays de datos:
  meses: Array<string> = ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"];
  lasemana: Array<string> = ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"]
  diassemana: Array<string> = ["lun","mar","mié","jue","vie","sáb","dom"];
 
  pos11;  pos12;  pos13;  pos14;  pos15;  pos16;  pos17;  
  pos21;  pos22;  pos23;  pos24;  pos25;  pos26;  pos27;  
  pos31;  pos32;  pos33;  pos34;  pos35;  pos36;  pos37;
  pos41;  pos42;  pos43;  pos44;  pos45;  pos46;  pos47;
  pos51;  pos52;  pos53;  pos54;  pos55;  pos56;  pos57;
  pos61;  pos62;  pos63;  pos64;  pos65;  pos66;  pos67;
  pos71;  pos72;  pos73;  pos74;  pos75;  pos76;  pos77;

  hoy;
  diasemhoy; //dia semana actual
  diahoy; //dia mes actual
  meshoy; //mes actual
  annohoy; //año actual
  // Elementos del DOM: en cabecera de calendario 
  tit; //cabecera del calendario
  ant; //mes anterior
  pos; //mes posterior
  // Elementos del DOM en primera fila
  f0;
  //Pie de calendario
  pie;

  //formulario: datos iniciales:
  mesant;
  mespos;

  // Definir elementos iniciales:
  mescal; //mes principal
  annocal; //año principal
  primeromes;
  ultimomes;
  verfila;
  verfilaactual;
  losdiasdelmes;

  imagenobtenida;
  imagenes;
  imaahora;
  id;
  tabla;
  caption: string;
  pages;
  pages2;
  rsx;
  numero;
  numerodias;
  colo;
  fechainicial;
  valor1;
  diasdisponibles;
  contador;
  empresas;
  grupos;
  inicio;
  fin;
  colore;
  supervisado;
  observaciones;
  nombre;
  dateNow ;
  constructor(
  	public navParams: NavParams,
    public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
  	public navCtrl: NavController,
  	public variables:VariablesProvider,
    public file: File,
    public events: Events,
    public params: NavParams,
    public viewCtrl: ViewController,
    private cdRef:ChangeDetectorRef
    ) { 
  
      this.nombre =  params.get('nombre');
      this.trabajador = params.get('trabajador');
      this.codigo = params.get('codigo');
      this.colo = params.get('colo');
      this.diahoy = params.get('diahoy');
      this.id = params.get('id');
      this.losdiasdelmes = params.get('losdiasdelmes');
      this.tabla = params.get('tabla');
      this.caption = params.get('caption');
      this.numero = params.get('codigo');
      this.rsx = params.get('rsx');
      this.dias = params.get('dias');
      this.inicio = params.get('inicio');
      this.fin = params.get('fin');
      this.variables.AnnoCal = params.get('ano');
      this.variables.MesCal = params.get('mes');
      
      this.myForm = this.fb.group({

        numerodias: [''],
        obra:[''],
        observaciones:[''],
        supervisado:['']
      });

     this.supervisado = "";
     this.textoboton = "Indique el responsable de la reserva";
     this.diasdisponibles=[];

   
    this.contador=0;

    var i;
    var x;
    for (x=0; x<this.rsx.length;x++) {
      if (this.rsx[x].ID == this.id){
        for (i=this.numero; i<1000;i++) {
          if (this.rsx[x][i]){

          }else{
            this.rsx[x][i]="no";
          }
          if (this.rsx[x][i]=="no") {
              this.contador++
              this.diasdisponibles.push(this.variables.zfill(this.contador,2));
          }else{
            break;
          } 
          if (this.contador>=this.losdiasdelmes.length) {
            break;
          }           
        }
      }
    }
    

    this.formulario.numerodias1 = "01";


    console.log("RESERVAS:" + this.variables.AnnoCal + "/" + this.variables.MesCal);
    
    this.fechainicial = this.variables.AnnoCal + "-" + this.variables.zfill(this.variables.MesCal+1,2) + "-" + this.numero;

}

ngAfterViewChecked()
{
  //console.log( "! con esto no da error !" );
  this.dateNow = new Date();
  this.cdRef.detectChanges();
}


abreclientes(){

      if(this.variables.CLIENTES_RAZSOCIAL==""){

       this.obtenerobras(this.valo);
       this.obtenerempresas(this.valo);
       this.obtenerturnos(this.valo);
       this.obtenerpuestos(this.valo);
       this.obtenergrupos(this.valo);


          let myModal = this.modalCtrl.create(ObjetoslinPage, {
             'idgrupo': "654321123456", 
              'caption': "Seleccione el trabajador al que se le asigna la reserva" ,
              'rsempresas': this.empresas,
              'rsobras': this.obras,
              'rspuestos': this.puestos,
              'rsturnos': this.turnos
          }
            );
          myModal.onDidDismiss(data => { 
            if (data.codigo) {
              this.textoboton = data.codigo + " - " + data.nombre ;
              this.trabajador = data.codigo;
            }
     
        }); 
          myModal.present();


      }

}

	obtenerVehiculosconreserva(trabajador,mes,ano){

	}


  reservarVehiculo(){

      var suma;
      suma = Number(this.fechainicial.substr(8, 2));
      suma = suma +  Number(this.formulario.numerodias1);

      this.todosLosVehiculos = [];

      let alert = this.alertCtrl.create({
        title: 'Reservar.',
        message: '¿Confirma la reserva desde el día  <br><br>'  + this.fechainicial + '.<br><br>Dejándolo libre el día <br><br>' + this.fechainicial.substr(0, 8) + suma + '?',
        cssClass: 'alertCustomCss',
        buttons: [{
            text: 'No',
            role: 'No',
            handler: () => {  }
          },{
            text: 'Si',
            handler: () => {
               if (this.formulario.obs1==''){
                  this.formulario.obs1='654321123456';
               }
               if (this.formulario.obra1==''){
                  this.formulario.obra1='654321123456';
               }

               //console.log("Colores:" + this.colore);    

               if (this.colore){
                 if (this.colore.substr(0, 1)=='#') {
                   this.colore=this.colore.substr(1);
                 }
               }else{
                  this.colore='336699';
               }
               if (this.formulario.obs1==''){
                  this.formulario.obs1='654321123456';
               }
                this.variables.confirmaReserva(this.trabajador, this.id,this.fechainicial,this.formulario.numerodias1, this.formulario.obra1,this.colore,this.formulario.obs1).then(
                data => {
                  this.todosLosVehiculos = data;
                  this.dismiss();
                }
              )

            }
          }
        ]
      });
      alert.present();

     }
   
 

editarreserva(id){

var texto;
var reservacompleta =  {};
var ano;
var mes;
var dia;

for (var i = 0; i < Number(this.rsx[0].FIN); ++i) {

reservacompleta["id"] = Number(this.id)+i;
texto = this.dias;

ano=texto.substring(0,texto.indexOf("-"));
if (ano.length==2){ ano = "20" + ano;}

mes=texto.substring(texto.indexOf("-")+1 ,texto.lastIndexOf("-"));
if (mes.length==1){ mes = "0" + mes;}

dia=texto.substring(texto.lastIndexOf("-")+1);
if (dia.length==1){dia = "0" + dia;}
    
texto = ano + "-" + mes + "-" + dia;

this.rsx[0].OBSERVACIONES = this.formulario.obs1;

//console.log("OBSERVACIONES:" + this.rsx[0].OBSERVACIONES + "/" + this.formulario.obs1);

reservacompleta["dia"] = texto;
reservacompleta["trabajador"] = this.rsx[0].TRABAJADOR;
reservacompleta["obra"] = this.rsx[0].OBRA;
reservacompleta["supervisado"] = this.rsx[0].SUPERVISADO;
reservacompleta["observaciones"] = this.rsx[0].OBSERVACIONES;
  
  this.variables.editarreservavehiculos(reservacompleta).then(
        data => {
  

        },
        err=>{
          console.log(err);
         }

        )


  }

  this.dismiss();

}

	eliminaReserva(value){

     //console.log("ueeeeeeeeeeeeeeee" + this.id);
      let alert = this.alertCtrl.create({
          title: 'Borrar.',
          message: '¿Confirma que desea liberar la reserva?',
          cssClass: 'alertCustomCss',
          buttons: [{
              text: 'No',
              role: 'No',
              handler: () => {  }
            },{
              text: 'Si',
              handler: () => {

                //console.log( Number(this.formulario.numerodias1)-1);

                for (var i = 0; i < Number(this.rsx[0].FIN); ++i) {

                  this.variables.eliminaReserva(Number(this.id)+i);
                }
               // this.funciones.eliminaReserva(this.ID)
               // this.obtieneDias();
               this.dismiss();

              }
            }
          ]
        });
        alert.present();
	}

  supervisarlo(value){

                /*for (var i = 0; i < Number(this.formulario.numerodias1); ++i) {
                  this.variables.eliminaReserva(Number(this.id)+i);
                }*/
      
      this.rsx[0].SUPERVISADO =  this.nombre;

 
  }
	




 valChange(campo:string, value:string, index:number):void{
      
      //alert("Campo->" + campo + "valor->" + value + "lugar->" + index)

      switch (campo) {
        
         case "OBJETO":
           //this.ojetos[index].PUESTO = value;
           break;

         default:
           // code...
           break;
       }
    }

ponencampoinicial(campo:string, value:string):void{

        switch (campo) {
          case "OPCION":
            if (value=="salas") { 
              this.variables.OpcionAReservar  ="SALAS";
              this.variables.TIPO = "sala";
      
              
            } else {
              this.variables.OpcionAReservar  ="VEHICULOS";              
              this.variables.TIPO = "vehiculo";
            }

            this.navCtrl.setRoot(this.navCtrl.getActive().component);
           
          default:
             // code...
          break;
         }

 }

ponencampo(campo:string, value:string):void{

	      switch (campo) {
	        case "DIA":
	           this.formulario.numerodias1 = value;
             break;
          case "COLOR":
            this.colore = value;
  	        break;
          case "OBRA":
             this.formulario.obra1 = value;
            break;
	        default:
	           // code...
	        break;
	       }
 }
   
salir(){
   this.navCtrl.push(HomePage);
}


  obtenerpuestos(filtro){

    this.variables.obtienepuestos(filtro).then(
          data => {

          this.puestos = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

    obtenerempresas(filtro){

    this.variables.obtieneempresas(filtro).then(
          data => {

          this.empresas = data;
          //console.log(this.empresas);


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

    obtenergrupos(filtro){

    this.grupos = [];

    this.variables.obtienegrupos().then(
          data => {
            
            this.grupos = data;

          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

    obtenerobras(filtro){

    this.variables.obtieneobrasconfiltro(filtro).then(
          data => {

          this.obras = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }


    obtenerturnos(filtro){

    this.variables.obtieneturnos(filtro).then(
          data => {

          this.turnos = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }


onChange($event) {

    this.variables.DIA  = $event;
    //this.storage.set('DIASELECIONADO', this.variables.DIA );
    //this.obtenertrabajadores("formulario");
    //this.formulario.dia1 = cadena.substr(8, 2);
    //this.formulario.mes1 = cadena.substr(5, 2);
  }



dismiss() {

    this.variables.AnnoCal = this.annocal;
    this.variables.MesCal = this.mescal;
    
    this.viewCtrl.dismiss({}); 
  }

}



// WEBPACK FOOTER //
// ./src/pages/reservaslin/reservaslin.ts